var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.931 4.8587L19.381 6.4087L19.3777 6.40547H8.52773C7.67169 6.40547 6.97773 7.09943 6.97773 7.95547V23.4555C6.97773 24.3115 7.67169 25.0055 8.52773 25.0055H24.0277C24.8838 25.0055 25.5777 24.3115 25.5777 23.4555V12.6119L27.1277 11.0619V23.4555C27.1277 25.1676 25.7398 26.5555 24.0277 26.5555H8.52773C6.81565 26.5555 5.42773 25.1676 5.42773 23.4555V7.95547C5.42773 6.24339 6.81565 4.85547 8.52773 4.85547H20.9277L20.931 4.8587ZM10.0777 21.9055L11.6277 17.2555L24.0277 4.85547L27.1277 7.95547L14.7277 20.3555L10.0777 21.9055ZM13.8905 19.0007L24.9357 7.95547L24.0277 7.0475L12.9825 18.0928L12.5285 19.4547L13.8905 19.0007Z",
    fill: "#1B0076"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompose);
export default __webpack_public_path__ + "static/media/compose.31a5cbd1.svg";
export { ForwardRef as ReactComponent };